export const FIELD_STYLE_OUTLINED = 'outlined';
export const FIELD_STYLE_NAKED = 'naked';